export enum Type {
  CREATION_REQUEST = 'app/wizard-export/CREATION_REQUEST',
  CREATION_SUCCESS = 'app/wizard-export/CREATION_SUCCESS',
  CREATION_FAILURE = 'app/wizard-export/CREATION_FAILURE',
  CREATION_CLEAR = 'app/wizard-export/CREATION_CLEAR',
  CREATION_STATUS_POLL_REQUEST = 'app/wizard-export/CREATION_STATUS_POLL_REQUEST',
  CREATION_STATUS_POLL_SUCCESS = 'app/wizard-export/CREATION_STATUS_POLL_SUCCESS',
  CREATION_STATUS_POLL_FAILURE = 'app/wizard-export/CREATION_STATUS_POLL_FAILURE',

  CREATE_CREATION_ASSET_REQUEST = 'app/wizard-export/CREATE_CREATION_ASSET_REQUEST',
  CREATE_CREATION_ASSET_SUCCESS = 'app/wizard-export/CREATE_CREATION_ASSET_SUCCESS',
  CREATE_CREATION_ASSET_FAILURE = 'app/wizard-export/CREATE_CREATION_ASSET_FAILURE',
  CREATE_CREATION_ASSET_CLEAR = 'app/wizard-export/CREATE_CREATION_ASSET_CLEAR',
}
